import React, {FC} from "react";
import {Button, Modal} from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { LANG_COMMON_ERROR } from "../../lang";

interface Props {
    message: string
    show: boolean
    onHide: () => void
}
const Error: FC<Props> = ({message, show,onHide}) => {
    return (
        <Modal
            size="sm"
            show={show}
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-sm"
            className="modal-error"
            centered
        >
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title id="example-modal-sizes-title-sm">
                    <FormattedMessage {...LANG_COMMON_ERROR}/>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>{message}</h6>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-light" onClick={onHide} className="btn-custom btn-custom-light">
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default Error;